import(/* webpackMode: "eager" */ "/app/src/app/industry/page.tsx");
